import RepositoryFactory from "../../admin/apis/index";
const attributes = RepositoryFactory.EcomAttributes;

export default {
  addAttributes({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await attributes.addAttributes(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  addAttributesValue({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await attributes.addAttributesValue(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editAttributesValue({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await attributes.editAttributesValue(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAttributes({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await attributes.getAttributes();

        commit("SET_ATTRIBUTES", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSingleAttributesPrim({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await attributes.getSingleAttributes(payload);

        commit("SET_SINGLE_ATTRIBUTES", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSingleAttributesSec({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await attributes.getSingleAttributes(payload);

        commit("SET_SINGLE_ATTRIBUTES_SEC", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
